import React from "react";
import Dashboard from "./Dashboard";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Scope1Layout from "../../../Layout/Scope1Layout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import { useUser } from "../../../context/AuthContext";

const Scope1Dashboard = () => {
  const { user } = useUser();
  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <Scope1Layout />}
    >
      <Unauthorized
        requiredModule={
          "Environment | Scope 1 | Stationary Combustion" ||
          "Environment | Scope 1 | Fugitive Emissions" ||
          "Environment | Scope 1 | Mobile Combustion" ||
          "Environment | Scope 1 | Overview"
        }
      >
        <Dashboard />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Scope1Dashboard;
